import React from "react"
import { FormattedMessage } from "react-intl"
import Integrations from "../../../integration/Integrations"
import Proposal from "../../../proposal/proposal.component"
import { EventObjectDto } from "../../../state/event/Event"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import { InvoiceDto } from "../../../state/invoice/models"


type OwnProps = {
    object: EventObjectDto
    invoice: InvoiceDto
    proposal: Proposal
}

const InvoiceExportedToZendeskSupportEvent = (props: OwnProps) => {
    const type = props.object.attributes.entityType
    const Url = Integrations.getExternalOrderUrl(props.object)

    const renderMessage = () => {
        switch (type) {
        case "main":
            return <FormattedMessage
                id="invoice.analytics.events.exported.zendesk_support.text"
                defaultMessage="Invoice {identifier} has been exported to Zendesk Support, ticket #{externalId}"
                values={{
                    identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                    externalId:  props.object.attributes.externalId,
                }}
            />
        default:
            return <></>
        }
    }
    
    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <p className={"mb-2"} data-document-event="invoice-exported">
                    {renderMessage()}
                </p>
            </div>

            <div className={"col-12 d-flex align-items-center flex-wrap"}>
                <div className={"mr-3"}>
                    <a href={Url} target="_blank" rel="noreferrer">
                        {Integrations.getIntegrationLogoImage(INTEGRATION_KEY.ZENDESK_SUPPORT, 80, 21)}
                    </a>
                </div>
                {Url &&
                    <div className={""}>
                        <p className={"mb-0"}>
                            <a href={Url} target={"_blank"} className={"btn btn-sm btn-outline-primary"} rel="noreferrer">
                                <FormattedMessage
                                    id="invoice.analytics.events.exported.zendesk_support.open"
                                    defaultMessage="Open ticket in Zendesk support"
                                />
                            </a>
                        </p>
                    </div>
                }
            </div>
        </div>
    )
}

export default InvoiceExportedToZendeskSupportEvent


// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-exported-zendesk-support.component.tsx